import React, { useEffect, useState } from 'react'
import { useGetSubscriptionStatistics } from '../../hooks/useGetSubscriptionStatistics';
import { useForm } from 'react-hook-form';
import { ApexOptions } from 'apexcharts';
import { Button, Card, ChevronDownIcon, Flex, Heading } from '@radix-ui/themes';
import { useGetFacultiesQuery } from '../../hooks/useGetFacultiesQuery';
import { useGetDepartamentsQuery } from '../../hooks/useGetDepartamentsQuery';
import { useGetCoursesQuery } from '../../hooks/useGetCoursesQuery';
import SelectComponent from '../../components/inputs/Select/SelectComponent';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { useGetCoursesSubjectsQuery } from '../../hooks/useGetCoursesSubjectsQuery';
import Chart from 'react-apexcharts';
import { Lists } from '../../components/common/Lists';
import TableComponent from '../../components/common/Tables';
import RadioGroupComponent from '../../components/inputs/RadioGroup/RadioGroupComponent';
import { ChevronUpIcon } from '@radix-ui/react-icons';
import { useGetAcademicYearQuery } from '../../hooks/useGetAcademicYearQuery';
import { useGetCurrentAcademicYearQuery } from '../../hooks/useGetCurrentAcademicYearQuery';
import { RegimeOptions } from '../../utils/studentUtils';
import { useGetUniversitiesQuery } from '../../hooks/useGetUniversitiesQuery';
import { useChartTheme } from '../../hooks/useChartTheme';

const columnNamesMap: { [key: string]: string } = {
    academicYear: "Ano Acadêmico",
    course: "Curso",
    subject: "Disciplina",
    level: "Ano",
    semester: "Semestre",
    total: "Total Inscritos",
    regime:"Regime"

};

export const SubscriptionsStatistics = () => {
    const { withTheme } = useChartTheme();
    const [currentPage, setCurrentPage] = useState(1);
    const [showFilters, setShowFilters] = useState(true);
    const {  data: academicYears, isLoading: isLoadingAcademicYears, isError: errorAcademicYears} = useGetAcademicYearQuery({ PageNumber: currentPage, PageSize: 400 });
      const { data: currentYear } = useGetCurrentAcademicYearQuery();
      const defaultValues =  {
        IdFaculty: "",
        IdDepartament: "",
        IdUniversity: "",
        IdCourse: "",
        IdAcademicYear:currentYear?.id??"",
        IdSubject: "",
        Level: "",
        Semester: "",
        Regime: ""
    }
    const { control, handleSubmit, watch, getValues, setValue, formState: { errors } } = useForm({
        defaultValues
    });
    const filters = watch();


    const { data, status } = useGetSubscriptionStatistics({
        PageNumber: currentPage,
        PageSize: 100,
        ...filters,
        Semester: +filters.Semester,
        Level: +filters.Level,
        Regime: +filters.Regime
    },{ enabled: !!getValues('IdCourse')});
      const { data:universities, isLoading: isLoadingUniversities, isError: errorUniversities, refetch: refetchUniversities } = useGetUniversitiesQuery({ PageNumber: 1, PageSize: 400 });
    
    const { data: faculties, isLoading: isLoadingFaculties, isError: errorFaculties, refetch:refetchFaculties } = useGetFacultiesQuery({ PageNumber: 1, PageSize: 400 ,IdUniversity:getValues('IdUniversity')});
    
    const { data: departaments, isLoading: isLoadingDepartaments, isError: errorDepartaments, refetch: refreshDepartaments } = useGetDepartamentsQuery(
        { PageNumber: 1, PageSize: 400, IdFaculty: getValues('IdFaculty') },
        { enabled: !!getValues('IdFaculty') }
    );
    const { data: courses, isLoading: isLoadingCourses, isError: errorCourses, refetch: refreshCourses } = useGetCoursesQuery({ PageNumber: 1, PageSize: 400, IdDepartament: getValues('IdDepartament') },
        { enabled: !!getValues('IdDepartament') }
    );
    const { data: courseSubjects, isLoading: isLoadingCoursesSubjects, isError: errorCourseSubjects, refetch: refreshCourseSubjects } = useGetCoursesSubjectsQuery({
        PageNumber: currentPage, PageSize: 400, 
        IdCourse: getValues('IdCourse'),
        Level: +getValues('Level'),
        Semester: +getValues('Semester'),
    },);


    const handleFacultyChange = (idFaculty: string) => {
        setValue('IdFaculty', idFaculty);
        refreshDepartaments();
    };

    const handleDepartamentChange = (idDepartament: string) => {
        setValue('IdDepartament', idDepartament);
        refreshCourses();
    };

    const handleCourseChange = async (idCourse: string) => {
        setValue('IdCourse', idCourse);
        // refreshCourseSubjects();
         setValue("IdSubject", "");
    }
    const handleCourseSubjectChange = async (idSubject: string) => {
        setValue('IdSubject', idSubject);
        
    }
    const handleLevelChange = async (e: any) => {
        var level = e.target.value;
        setValue("Level", level);
        // refreshCourseSubjects()
          setValue("IdSubject", "");

    }
    const handleSemesterChange = async (e: any) => {
        var semester = e.target.value;
        setValue("Semester", semester);
        // refreshCourseSubjects()
        setValue("IdSubject", "");
    }


    const chartOptions: ApexOptions = {
        chart: {
            type: "bar",
            height: 350,
        },
        title: {
            text: "Inscrições por Curso e Disciplina",
            align: "center",
        },
        xaxis: {
            categories: data?.map((stat) => `${stat.course} | ${RegimeOptions[stat?.regime!]??stat?.regime} |  - ${stat.subject}`) || [],
            title: {
                text: "Curso e Disciplina",
            },
        },
        yaxis: {
            title: {
                text: "Total de Inscritos",
            },
        },
        series: [
            {
                name: "Total de Inscritos",
                data: data?.map((stat) => stat.total) || [],
            },
        ],
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const subjects = Object.values(
        courseSubjects?.items?.reduce((acc, cs) => {
            if (cs.idSubject) {  // Verificamos que idSubject exista
                acc[cs.idSubject] = {
                    value: cs.idSubject,
                    label: cs.subject ?? ""
                };
            }
            return acc;
        }, {} as Record<string, { value: string; label: string }>) ?? {}
    );

    useEffect(() => {
        if (academicYears?.items && academicYears.items.length > 0) {
            if (!getValues('IdAcademicYear')) {
                const mostRecentYear = academicYears.items[academicYears.items.length - 1];
                setValue('IdAcademicYear', mostRecentYear.id);
            }
        }
    }, [academicYears, setValue, getValues]);
    const handleUniversityChange = (id: string) => {
        setValue('IdUniversity', id);
        setValue('IdFaculty', '');
        setValue('IdDepartament', '');
        setValue('IdCourse', '');
        refetchFaculties();
      };
    return (
        <Card>
            <Flex gap='4' direction='column'>
                <Heading>
                    Inscrições por disciplina
                </Heading>

                {/* <Button 
                        variant="soft" 
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Flex align="center" gap="2">
                            {showFilters ? "Esconder Filtros" : "Mostrar Filtros"}
                            {showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
                        </Flex>
                    </Button> */}
                    {/* {
                        showFilters && */}
                         {/* ( */}
                             <form onSubmit={handleSubmit(() => { })}>
                        <Flex gap='4' direction='column'>
                            
                            <Flex gap='4'>
                            <SelectComponent
                                name="IdUniversity"
                                label="Instituição de Ensino Superior"
                                control={control}
                                errors={errors}
                                style={{ width: '100%' }}
                                options={universities?.items.map(u => ({
                                    value: u.id ?? "",
                                    label: u.description ?? ""
                                }))}
                                itemsLoading={isLoadingUniversities}
                                itemsError={errorUniversities}
                                onSelect={handleUniversityChange}
                                required={true}
                            />
                                <SelectComponent name="IdFaculty" label='Unidade orgânica' control={control} errors={errors} style={{ width: '100%' }}
                                    options={faculties?.items.map(faculty => ({
                                        value: faculty.id ?? "",
                                        label: faculty.description ?? ""
                                    }))}
                                    onSelect={handleFacultyChange}
                                    itemsError={errorFaculties}
                                    itemsLoading={isLoadingFaculties}
                                />
                                <SelectComponent name="IdDepartament" label='Departamento' control={control} errors={errors} style={{ width: '100%' }}
                                    options={departaments?.items.map(departament => ({
                                        value: departament.id ?? "",
                                        label: departament.description ?? ""
                                    }))}
                                    onSelect={handleDepartamentChange}
                                    itemsError={errorDepartaments}
                                    itemsLoading={isLoadingDepartaments}
                                />
                                <SelectComponent name="IdCourse" label='Curso' control={control} errors={errors} style={{ width: '100%' }}
                                    options={courses?.items.map(course => ({
                                        value: course.id ?? "",
                                        label: course.name ?? ""
                                    }))}
                                    onSelect={
                                        handleCourseChange
                                    }
                                    itemsError={errorCourses}
                                    itemsLoading={isLoadingCourses}
                                />
    
                            </Flex>
                            <Flex gap='4'>
                                <TextFieldComponent
                                    name="Level"
                                    label="Ano"
                                    control={control}
                                    errors={errors}
                                    fieldProps={{ placeholder: 'Ano', onChange: handleLevelChange, type: 'number' }} style={{ width: '100%' }}
                                />
                                <TextFieldComponent
                                    name="Semester"
                                    label="Semestre"
                                    control={control}
                                    errors={errors}
                                    fieldProps={{ placeholder: 'Semestre', onChange: handleSemesterChange, type: 'number' }} style={{ width: '100%' }}
    
                                />
                                <SelectComponent name="IdSubject" label='Cadeira' control={control} errors={errors} style={{ width: '100%' }}
                                    options={subjects}
                                    onSelect={
                                        handleCourseSubjectChange
                                    }
                                    itemsError={errorCourseSubjects}
                                    itemsLoading={isLoadingCoursesSubjects}
                                />
                            </Flex>
                        <Flex gap="4">
                            <SelectComponent name="IdAcademicYear" label='Ano Acadêmico' control={control} errors={errors} style={{ width: '35%' }}
                                options={academicYears?.items.map(ac => ({
                                    value: ac.id ?? "",
                                    label: ac.year ?? ""
                                }))}
                                itemsError={errorAcademicYears}
                                itemsLoading={isLoadingAcademicYears}
                            />

                            <RadioGroupComponent name="Regime" label="Regime" control={control} errors={errors} style={{ width: '100%' }}
                                options={[
                                    { value: "1", label: "Laboral" }
                                    , { value: "2", label: "Pós Laboral" }
                                    , { value: "3", label: "Distância" }
                                ]}
                                fieldProps={{
                                    style: { display: 'flex', flexDirection: 'row', gap: '16px' }
                                }}
                            />
                        </Flex>
                        </Flex>
                    </form>
                    {/* ) */}
                    {/* } */}
               
                <Lists
                    status={status}
                    TableComponent={() => (
                        <TableComponent
                            columns={Object.keys(columnNamesMap)}
                            items={data?.map(d => {
                                return { ...d, regime: RegimeOptions[d?.regime!] ?? d?.regime }
                            })}
                            options={[]}
                            columnNamesMap={columnNamesMap}
                            totalPages={1}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        />
                    )}
                />
                {data && data?.length > 0 && (
                    <Chart options={withTheme(chartOptions)} series={chartOptions.series} type="bar" height={350} />
                )}
            </Flex>

        </Card>
    )
}
